import Vue from 'vue'
import VueRouter from 'vue-router'
import Forbidden from '../components/pages/Forbidden.vue'
import NotFound from '../components/pages/NotFound.vue'
import InternalServerError from '../components/pages/InternalServerError.vue'
import Maintenance from '../components/pages/Maintenance.vue'
import BadGateway from '../components/pages/BadGateway.vue'
import Home from '../components/pages/Home.vue'
import Talkshows from '../components/pages/Talkshows.vue'
import TalkshowsArchives from '../components/pages/TalkshowsArchives.vue'
import TalkshowsExhibitors from '../components/pages/TalkshowsExhibitors.vue'
import Exhibitors from '../components/pages/Exhibitors.vue'
import About from '../components/pages/About.vue'
import Artworks from '../components/pages/Artworks.vue'
import ArtworkCategory from '../components/pages/ArtworkCategory.vue'
import ArtworkCategoryJ100 from '../components/pages/ArtworkCategoryJ100.vue'
import ArtworkCategoryOrganizer from '../components/pages/ArtworkCategoryOrganizer.vue'
import ArtworkCategoryTwitter from '../components/pages/ArtworkCategoryTwitter.vue'
import ArtworkCategoryJtg from '../components/pages/ArtworkCategoryJtg.vue'
import ArtworkCategoryWeibo from '../components/pages/ArtworkCategoryWeibo.vue'
import ArtworksWinner from '../components/pages/ArtworksWinner.vue'
import Specials from '../components/pages/Specials.vue'
import UpdateInfo from '../components/pages/UpdateInfo.vue'
import ReportCanon from '../components/pages/reports/ReportCanon.vue'
import ReportRaytrek from '../components/pages/reports/ReportRaytrek.vue'
import ReportBiei from '../components/pages/reports/ReportBiei.vue'
import TokenReceive from '../components/pages/TokenReceive.vue'

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { title: '東京カメラ部2021写真展 Online Exhibition「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '2019年に東京カメラ部とその分室で9億人を超える人々が約2,300万作品の中から選んだ作品「10選2019」を中心に新作、自信作を追加。更に2012年、2013年、2014年、2015年、2016年、2017年、2018年に選ばれた10選メンバーを加えた、10選8世代による合同展示。フォトコンテスト「日本写真100景」入選作品「"My Precious" Photo Contest」入選作品を加え、約289作品を展示。' }
  },
  {
    path: '/forbidden',
    name: 'forbidden',
    component: Forbidden
  },
  {
    path: '/not-found',
    name: 'notFound',
    component: NotFound
  },
  {
    path: '/internal-server-error',
    name: 'internalServerError',
    component: InternalServerError
  },
  {
    path: '/bad-gateway',
    name: 'badGateway',
    component: BadGateway
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    component: Maintenance
  },
  // 個別ページ以下 10選
  {
    path: '/t10s/:year/:id/images/:winningWorkId',
    name: 't10sImage',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/t10s/:year/:id/portfolios/:portfolioId/:index',
    name: 't10sPortfolioIndex',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/t10s/:year/:id/portfolios/:portfolioId',
    name: 't10sPortfolio',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/t10s/:year/:id',
    name: 't10s',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  // 個別ページ以下 100景
  {
    path: '/j100v/:area/:pref/:id/images/:winningWorkId',
    name: 'j100vImage',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/j100v/:area/:pref/:id/portfolios/:portfolioId/:index',
    name: 'j100vPortfoliosIndex',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/j100v/:area/:pref/:id/portfolios/:portfolioId',
    name: 'j100vPortfolios',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/j100v/:area/:pref/:id',
    name: 'j100v',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  // 個別ページ以下 主催者企画Twitter
  {
    path: '/organizer/twitter/:category/:id/images/:winningWorkId',
    name: 'twitterImage',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/organizer/twitter/:category/:id/portfolios/:portfolioId/:index',
    name: 'twitterPortfolioIndex',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/organizer/twitter/:category/:id/portfolios/:portfolioId',
    name: 'twitterPortfolio',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/organizer/twitter/:category/:id',
    name: 'twitter',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  // 個別ページ以下 主催者企画jtg
  {
    path: '/organizer/jtg/:id/images/:winningWorkId',
    name: 'jtgImage',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/organizer/jtg/:id/portfolios/:portfolioId/:index',
    name: 'jtgPortfoliosIndex',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/organizer/jtg/:id/portfolios/:portfolioId',
    name: 'jtgPortfolios',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/organizer/jtg/:id',
    name: 'jtg',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  // 個別ページ以下 主催者企画weibo
  {
    path: '/organizer/weibo/:id/images/:winningWorkId',
    name: 'weiboImage',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/organizer/weibo/:id/portfolios/:portfolioId/:index',
    name: 'weiboPortfoliosIndex',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/organizer/weibo/:id/portfolios/:portfolioId',
    name: 'weiboPortfolios',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/organizer/weibo/:id',
    name: 'weibo',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  // 個別ページ以下 協賛団体展示
  {
    path: '/sponsors/:id/images/:winningWorkId',
    name: 'sponsorsImage',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/sponsors/:id/portfolios/:portfolioId/:index',
    name: 'sponsorsPortfoliosIndex',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/sponsors/:id/portfolios/:portfolioId',
    name: 'sponsorsPortfolios',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/sponsors/:id',
    name: 'sponsors',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  // カテゴリページ 10選
  {
    path: '/t10s/:year',
    name: 't10sCategoryYear',
    component: ArtworkCategory,
    meta: { title: '東京カメラ部10選 | 作品展示 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/t10s',
    name: 't10sCategory',
    component: ArtworkCategory,
    meta: { title: '東京カメラ部10選 | 作品展示 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  // カテゴリページ 100景
  {
    path: '/j100v/:area/:pref',
    name: 'j100vCategoryPref',
    component: ArtworkCategoryJ100,
    meta: { title: '日本写真100景 | 作品展示 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/j100v/:area',
    name: 'j100vCategoryArea',
    component: ArtworkCategoryJ100,
    meta: { title: '日本写真100景 | 作品展示 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/j100v',
    name: 'j100vCategory',
    component: ArtworkCategoryJ100,
    meta: { title: '日本写真100景 | 作品展示 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  // カテゴリページ 主催者企画
  {
    path: '/organizer/twitter/:category',
    name: 'twitterCategoryCategory',
    component: ArtworkCategoryTwitter,
    meta: { title: '主催者企画 | 作品展示 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/organizer/twitter',
    name: 'twitterCategory',
    component: ArtworkCategoryTwitter,
    meta: { title: '主催者企画 | 作品展示 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/organizer/jtg',
    name: 'jtgCategory',
    component: ArtworkCategoryJtg,
    meta: { title: '主催者企画 | 作品展示 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/organizer/weibo',
    name: 'weiboCategory',
    component: ArtworkCategoryWeibo,
    meta: { title: '主催者企画 | 作品展示 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/organizer',
    name: 'organizer',
    component: ArtworkCategoryOrganizer,
    meta: { title: '主催者企画 | 作品展示 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  // カテゴリー 協賛団体展示
  {
    path: '/sponsors',
    name: 'sponsorsCategory',
    component: Specials,
    meta: { title: '協賛団体展示 | 作品展示 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/exhibitors',
    name: 'exhibitors',
    component: Exhibitors,
    meta: { title: '展示者一覧 | 作品展示 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/about',
    name: 'about',
    component: About,
    meta: { title: '開催概要 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/artworks',
    name: 'artworks',
    component: Artworks,
    meta: { title: '作品展示 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/events',
    name: 'events',
    component: Talkshows,
    meta: { title: '主催者公式イベント | イベントカレンダー |  東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/events/exhibitors',
    name: 'eventsExhibitors',
    component: TalkshowsExhibitors,
    meta: { title: '出展者自主企画イベント | イベントカレンダー |  東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/events/archives',
    name: 'eventsArchives',
    component: TalkshowsArchives,
    meta: { title: '主催者イベントアーカイブ | イベントカレンダー |  東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/updateinfo',
    name: 'updateinfo',
    component: UpdateInfo,
    meta: { title: 'アップデート情報 | 東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  // リポートページ
  {
    path: '/events/report_canon',
    name: 'reportCanon',
    component: ReportCanon,
    meta: { title: 'キヤノンマーケティングジャパン株式会社「EOS R、 EOS R5 、そして今 EOS R3 へ」|トークショーレポート｜東京カメラ部2021写真展 Online Exhibition「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/events/report_raytrek',
    name: 'reportRaytrek',
    component: ReportRaytrek,
    meta: { title: '株式会社サードウェーブ「クリエイターPC視点 raytrekのレタッチお悩み解決Before & Afterご紹介」|トークショーレポート｜東京カメラ部2021写真展 Online Exhibition「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/events/report_biei',
    name: 'reportBiei',
    component: ReportBiei,
    meta: { title: '美瑛町（ＮＰＯ法人 美瑛町写真映像協会）「カメラと旅する北海道・美瑛町」|トークショーレポート｜東京カメラ部2021写真展 Online Exhibition「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/token_receive',
    name: 'tokenReceive',
    component: TokenReceive,
    meta: { title: '東京カメラ部2021写真展 Online Exhibition 「だから、世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '*',
    redirect: '/not-found'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) return savedPosition // 戻るボタン対応
    // 画像詳細とポートフォリオから復帰した場合は、元のスクロール位置を保持する
    if (
      (to && to.path && to.path.indexOf('/images/') >= 0) ||
      (from && from.path && from.path.indexOf('/images/')) >= 0 ||
      (to && to.path && to.path.indexOf('/portfolios/') >= 0) ||
      (from && from.path && from.path.indexOf('/portfolios/')) >= 0
    ) {
      return null
    } else {
      // スクロール位置を左上にリセット
      return { x: 0, y: 0 }
    }
  }
})

// bodyにパスの第1階層を名前としたclassを設定する処理
router.beforeEach(async (to, from, next) => {
  if (to.path === '/') {
    document.body.className = 'topPage'
  } else {
    const pathArray = to.path.split('/')
    if (pathArray.length > 1 && pathArray[1]) {
      document.body.className = pathArray[1]
    } else {
      document.body.className = ''
    }
  }
  next()
})

export default router
